// extracted by mini-css-extract-plugin
export var card = "StepCard-module--card--nKnuS";
export var cardTitle = "StepCard-module--cardTitle--EySIX";
export var cardsGrid = "StepCard-module--cardsGrid--AvgIJ";
export var cardsWrapper = "StepCard-module--cardsWrapper--mlaFu";
export var gradientCircle = "StepCard-module--gradientCircle--ylMc2";
export var iconImage = "StepCard-module--iconImage--tSwGK";
export var numberImage = "StepCard-module--numberImage--Oplsp";
export var stepIcon = "StepCard-module--stepIcon--m9JJO";
export var stepNumber = "StepCard-module--stepNumber--UnnDy";